import React, { useContext } from 'react';
import { $, StarberryComponentContext, useModuleDefinition } from '@starberry/components';
import { Icon } from '@chakra-ui/react';

const Rooms = ({ bedroomIconProp, bathroomIconProp, receptionIconProp }) => {
  const context = useContext(StarberryComponentContext);
  const { data: { bedroom, bathroom, reception } } = context;

  const roomsArr = [
    { label: 'bedroom', quantity: bedroom, iconProps: bedroomIconProp },
    { label: 'bathroom', quantity: bathroom, iconProps: bathroomIconProp },
    { label: 'reception', quantity: reception, iconProps: receptionIconProp }
  ]

  const roomsGreaterThanZero = ({ quantity }) => quantity;
  // Remove empty rooms from array
  const rooms = roomsArr.filter(roomsGreaterThanZero);

  const MyLatestPropertyModule = useModuleDefinition({
    $: 'Flex',
    props: {
      direction: 'row',
    },
    children: ({ label, quantity, iconProps }) => [
      {
        component: Icon,
        color: $('constants.colors.icons'),
        mr: 1,
        boxSize: 6,
        as: $(`constants.icons.${label}`),
        ...iconProps
      },
      { $: 'Text', children: quantity },
    ]
  })

  return rooms?.map((props) => {
    return <MyLatestPropertyModule {...props} />
  })
}

const PropertyRooms = {
  $: 'Stack',
  props: {
    spacing: 4,
    direction: 'row',
  },
  children: ({ bedroomIconProp, bathroomIconProp, receptionIconProp }) => [
    {
      component: Rooms,
      bedroomIconProp: bedroomIconProp,
      bathroomIconProp: bathroomIconProp,
      receptionIconProp: receptionIconProp
    },
  ],
};

export default PropertyRooms;
